/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InFilesize: core.serialization.ObjectSchema<serializers.InFilesize.Raw, Truvity.InFilesize> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.number()),
    });

export declare namespace InFilesize {
    export interface Raw {
        values: number[];
    }
}
